module.exports = __webpack_public_path__ + "static/media/test18_4.bd363cfa.png";